import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";
import { AgentRoute } from "../components/diagnosticAgent/util/agentRoutes";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useScreenSize } from "../components/diagnosticAgent/util/useScreenSize";
import { isCordovaApp } from "fe-common/analytics/analytics";
import { isIos } from "../installAppPopover/addToHomeScreenPopover";

const explorerBaseUrl = "https://editor.kahun.com/#/w-kahun/wcase/";

const navigator: any = window.navigator;
const shareExternalSupported = navigator.share;

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const PRODUCTION_ORIGIN = "https://diagnose.kahun.com";

export const useShareLinks = () => {
  const { isMobile } = useScreenSize();
  const queryParams = useQuery();
  return useMemo(() => {
    const shareLink = (id) => {
      const origin = isCordovaApp()
        ? PRODUCTION_ORIGIN
        : removeTrailingSlash(window.location.origin);

      queryParams.set("shareId", id);
      return `${origin}/agent/${AgentRoute.DD}?${queryParams.toString()}`;
    };

    const explorerShareLink = (id) => {
      return `${explorerBaseUrl}${id}`;
    };

    const SHARE_TEXT = "The following patient case was shared with you";

    const shareExternal = (id) => {
      const text = isIos() ? undefined : SHARE_TEXT;
      const title = isIos() ? SHARE_TEXT : "Patient case";
      if (shareExternalSupported && isMobile) {
        navigator.share({
          title,
          text,
          url: shareLink(id),
        });
      }
    };

    const explorerShareExternal = (id) => {
      if (shareExternalSupported && isMobile) {
        navigator.share({
          title: "Patient case",
          text: "The following patient case was shared with you",
          url: explorerShareLink(id),
        });
      }
    };

    return {
      shareLink,
      explorerShareLink,
      shareExternal,
      explorerShareExternal,
      // Allow external sharing only on mobile devices
      shareExternalSupported: shareExternalSupported && isMobile,
    };
  }, [queryParams, isMobile]);
};
